var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy061(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "copy-06 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.375 1.75H8.51667C9.82333 1.75 10.4767 1.75 10.976 2.00433C11.415 2.22803 11.772 2.58497 11.9957 3.024C12.25 3.52333 12.25 4.17667 12.25 5.48333V9.625M3.61667 12.25H8.34167C8.995 12.25 9.32167 12.25 9.57133 12.1228C9.79085 12.011 9.96932 11.8325 10.0812 11.613C10.2083 11.3633 10.2083 11.0367 10.2083 10.3833V5.65833C10.2083 5.005 10.2083 4.67833 10.0812 4.42867C9.96932 4.20915 9.79085 4.03068 9.57133 3.91883C9.32167 3.79167 8.995 3.79167 8.34167 3.79167H3.61667C2.96333 3.79167 2.63667 3.79167 2.387 3.91883C2.16749 4.03068 1.98902 4.20915 1.87717 4.42867C1.75 4.67833 1.75 5.005 1.75 5.65833V10.3833C1.75 11.0367 1.75 11.3633 1.87717 11.613C1.98902 11.8325 2.16749 12.011 2.387 12.1228C2.63667 12.25 2.96333 12.25 3.61667 12.25Z",
    stroke: "#056EE6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy061);
export default __webpack_public_path__ + "static/media/copy-06 1.04fe98c355cf82a3d272962fe364e43e.svg";
export { ForwardRef as ReactComponent };